
import { OverlayData } from "../ui/overlay/Overlay";
import BaseEvent from "./BaseEvent";


export default class UIEvent extends BaseEvent{
    static CLOSE_POPUP:string = "closePopup";

    static UPDATE_TOGGLE_CONTAINER_SIZE:string = "updateToggleContainerSize";
}